<!--
 * @Descripttion:
 * @version:
 * @Author: HeYang
 * @Date: 2019-06-04 18:38:54
 * @LastEditors: HeYang
 * @LastEditTime: 2020-10-30 16:22:08
 -->
<style lang="less" rel="stylesheet/less">
@import './common/style/reset.less';
@import './common/style/picker.less';
@import './common/style/common.less';

body,
.app-container,
.com-container,
.page-container {
	width: 100%;
	height: 100%;
	// padding-bottom: constant(safe-area-inset-bottom);
	// padding-bottom: env(safe-area-inset-bottom);
}
.page-container {
	max-width: 10rem;
	margin: 0 auto;
}
body {
	max-width: 10rem;
	margin: 0 auto !important;
}
// 页面定位元素
.com-container {
	position: relative;
}
// 页面内容滚动元素
.page-container {
	position: absolute;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	overflow: hidden;
}
// 真实页面内容滚动区域
.content-container {
	position: absolute;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	overflow: auto;
	padding-bottom: 3rem;
	-webkit-overflow-scrolling: touch;
}
// 授权弹窗
.how-do-pop {
	position: fixed;
	left: 0;
	right: 0;
	bottom: 0;
	top: 0;
	z-index: 9999;
	background-color: rgba(0, 0, 0, 0.5);
	img {
		display: block;
		width: 100%;
	}
}
</style>
<template>
	<div class="com-container">
		<!-- 路由匹配到的组件将渲染在这里 -->
		<!-- <transition name="fade"> -->
		<keep-alive include="Index,ScIndex,meIndex,Agreement,AnswerList,MeAskDetail,teacherList">
			<router-view></router-view>
		</keep-alive>
		<!-- </transition> -->
		<!--公共页脚部分-->
		<ComFooter v-if="isShowFooter"></ComFooter>
		<!--提示组件-->
		<transition name="fade" mode="in-out">
			<myAlertTip
				v-if="tip.isShow"
				@close-tip="tip.isShow = !tip.isShow"
				:text="tip.text"
				:time="tip.time"
			>
			</myAlertTip>
		</transition>
		<transition name="fade" mode="in-out">
			<LoadingModel v-show="loading.isShow">
				<span>{{ loading.text }}</span>
			</LoadingModel>
		</transition>
		<!-- 注册组件 -->
		<transition name="fade" mode="in-out">
			<newRegisterV2
				v-if="!isLogin && isDisplayLoginPop && !isApp && !isMiniProgram"
				:obj="obj"
				@loginSuc="bindUserOrder"
				@hasConpon="coupon"
			>
			</newRegisterV2>
		</transition>
		<!-- 新手引导组件 -->
		<transition name="fade" mode="in-out">
			<newUserPopV2 v-if="isLogin && isDisplayCouponPop && isShowFooter"></newUserPopV2>
		</transition>
		<!-- 链接跳进来的优惠券组件 -->
		<transition name="fade" mode="in-out">
			<newUserPopLink
				v-if="batchObj.isShow && isBirthdayType != 'birth'"
				:newUserObj="batchObj"
				@close="newUserCloseLink"
			></newUserPopLink>
		</transition>
		<transition name="fade" mode="in-out">
			<FrameCom v-if="isFrame" :obj="frameObj" @close="closeFrame"></FrameCom>
		</transition>
		<transition name="fade" mode="in-out">
			<birthdayComponent
				v-if="batchObj.isShow && isBirthdayType == 'birth'"
				:birthdayObj="batchObj"
				@close="newUserCloseLink"
			></birthdayComponent>
		</transition>
		<section v-if="freeListenHowtoPop" class="how-do-pop" @click.stop.prevent="howdoPopClick">
			<img src="./image/free_listen_howdo.png" alt="" />
		</section>
	</div>
</template>
<script>
import {commonFn} from './common/js/common.js';
import {apiPath} from './common/js/config.js';
import {addStatisticsCode} from './common/js/addStatisticsCode';
import myAlertTip from './common/components/modelBox.vue';
import newUserPopV2 from './common/components/newUserPopV2.vue';
import newUserPopLink from './common/components/newUserPopLink.vue';
import newRegisterV2 from './common/components/newRegisterV2.vue';
import ComFooter from './common/components/footer.vue';
import LoadingModel from './pages/compontents/loadingModel.vue';
import myAjax from './common/js/request';
import FrameCom from './common/components/frame.vue';
import birthdayComponent from './common/components/birthdayComponent.vue';
import {tarotSuanFaRoutes} from './common/js/taluoSuanFaConfig.js';

export default {
	name: 'appPage',
	components: {
		myAlertTip,
		ComFooter,
		LoadingModel,
		newRegisterV2,
		newUserPopLink,
		FrameCom,
		newUserPopV2,
		birthdayComponent
	},
	data() {
		return {
			isYdk: commonFn.isYdk(),
			roomObj: null,
			// 渠道
			channel: commonFn.getParams()['channel'] || localStorage.getItem('channel') || '',
			//优惠券批号
			batch: commonFn.getParams()['batch'] || '',
			batchObj: {
				uid: '',
				isShow: false,
				data: {
					name: '',
					value: '',
					mininum: ''
				}
			},
			frameObj: {
				image: '',
				url: ''
			},
			transitionName: '',
			// 新手引导弹窗
			newUserObj: {
				uid: '',
				isShow: false,
				data: {
					name: '',
					value: '',
					amount: '',
					mininum: '',
					desc: ''
				}
			},
			obj: {
				val: '登录',
				className: 'register',
				isClose: false,
				isQian: false,
				isQudao: false,
				isZXQudao: false, // 在线追问渠道
				isZXBZJPQudao: false // 在线追问—八字精辟渠道
			},
			// 注册弹框是否显示
			isRegister: false,
			/* 用户token */
			userToken:
				commonFn.getParams()['token'] ||
				localStorage.getItem('yiQiWenToken') ||
				commonFn.getCookieItem('_token') ||
				'',
			qianId: commonFn.getParams()['qian_id'] || '',
			order_id: commonFn.getParams()['order_id'] || '',
			order_type: commonFn.getParams()['type'] || '',
			source: commonFn.getParams()['source'] || '',
			url: commonFn.getParams()['url'] || '',
			isApp: !commonFn.isH5(),
			isFslpApp: commonFn.isFslpApp(),
			isBirthdayType: commonFn.getParams()['type'] || '', // 是否从短信跳转过来的生日优惠券链接
			hideFooterPath: [
				'/saleIndex',
				'/freeChatRoom',
				'/AddPhone',
				'/chatPaySuc',
				'/answerIndex',
				'/paySucGuide',
				'/taluoAsks',
				'/taluo',
				'/taluoPay',
				'/csDetail',
				'/scIndex',
				'/ScDetail',
				...tarotSuanFaRoutes
			],
			isMiniProgram: commonFn.parseUA().wxMiniprogram
		};
	},
	computed: {
		tip() {
			return this.$store.state.layer;
		},
		loading() {
			return this.$store.state.loading;
		},
		isFrame() {
			return this.$store.state.isFrame;
		},
		isLogin() {
			return this.$store.state.isLogin;
		},
		isDisplayLoginPop() {
			return this.$store.state.loginPop;
		},
		isDisplayCouponPop() {
			return this.$store.state.couponPop;
		},
		// 免费听活动如何授权弹窗
		freeListenHowtoPop() {
			return this.$store.state.freeListen.howdoPop;
		},
		// iOS知屿APP页面或小程序，隐藏全局弹窗，页面footer等
		isShowFooter() {
			const hidePath = [
				'/tzAskDetail',
				'/goodsOrder',
				'/goodsOrderDetail',
				'/csDetail',
				...tarotSuanFaRoutes
			];
			let {pathname = '/'} = location;

			return !hidePath.includes(pathname) && !this.isMiniProgram;
		}
	},
	methods: {
		async getQiFu() {
			try {
				let res = await myAjax.get('/v1/order/h5/give_pray_light', {
					channel: this.channel
				});

				if (res) {
					_senseTrack('$Scan', {
						$module: 'H5_window_view_PaidUser',
						$title: 'h5免费私聊弹窗浏览_付费用户'
					});
					commonFn.showCommonQifuPop();
				}
			} catch (error) {
				console.log('错误', error);
			}
		},
		layer(text, time) {
			this.$store.commit('showLayer', text);
		},
		showLoading(text) {
			this.$store.commit('showLoading', text);
		},
		hideLoading() {
			this.$store.commit('hideLoading');
		},
		closeFrame() {
			this.$store.commit('setFrame', 0);
		},
		newUserClose() {
			this.newUserObj.isShow = false;
			this.$store.commit('setCouponPop', false);
			commonFn.showFooter();
		},
		newUserCloseLink(isShowFooter = false) {
			this.batchObj.isShow = false;
			isShowFooter && commonFn.showFooter();
		},
		async closeEvent(is_bind) {
			/* 注册完成后弹窗新手引导 */
			this.isRegister = false;
			/* 登录成功后如果有签问id则绑定签问到用户 */
			await this.getFromId();
			if (this.qianId) {
				this.bindQian();
			} else {
				/* 注册完成强跳至问题页面 */
				if (this.order_id) {
					if (this.order_type == 1 && is_bind) {
						this.$router.push({
							path: `/freeChatRoom?room=${this.roomObj.room_id}&from=${this.roomObj.from_uid}&channel=${this.channel}`
						});
					} else {
						this.$router.push({
							path: '/MeQuestions'
						});
					}
				} else {
					if (this.batch) {
						this.coupon();
					} else {
						this.newsGuideHandler();
					}
				}
			}
		},
		async newsGuideHandler() {
			await myAjax
				.get(apiPath.isPopBoot, {
					step: 2,
					channel: this.channel
				})
				.then((res) => {
					if (res.new_user == 1) {
						this.newUserObj.data = res.coupon || {};
						this.newUserObj.uid = res.uid;
						this.newUserObj.isShow = true;
						// this.$store.commit("setMayLikePop", true);
					} else {
						this.newUserObj.isShow = false;
						// this.$store.commit("setMayLikePop", false);
					}
				})
				.catch((e) => {});
		},
		/* 绑定签文id */
		bindQian() {
			myAjax
				.post(apiPath.bindQian, {id: this.qianId})
				.then((res) => {
					/* 跳转到我的签问页面 */
					this.$router.push({
						path: '/meQian'
					});
				})
				.catch((e) => {});
		},
		async getFromId() {
			var data = {
				answer_uid: 0,
				ident: 'zxcs'
			};
			//this.showLoading('创建中');
			await myAjax
				.post(apiPath.getRoomId, data)
				.then((res) => {
					this.roomObj = res;
					// this.$router.push({
					// 	path: `/freeChatRoom?room=${this.roomObj.room_id}&from=${this.roomObj.from_uid}&channel=${this.channel}`
					// })
				})
				.catch((e) => this.layer(e));
			//this.hideLoading();
		},
		/* 用户绑定在线的订单 */
		async bindUserOrder() {
			if (this.order_type == 'scGuide') {
				// 闪测，快速提问，普通问题的单改成单独跳到一个引导页
				this.$router.push({
					path: `/paySucGuide?type=${this.order_type}&order_id=${this.order_id}`
				});
			}
		},
		/*短信优惠券链接*/
		coupon() {
			myAjax
				.post(apiPath.couponApi, {
					batch: this.batch
				})
				.then((res) => {
					if (res.amount) {
						this.batchObj.isShow = true;
						this.batchObj.data = res;
					} else {
						this.batchObj.isShow = false;
						if (res.status == -1) {
							this.layer(res.msg, 2000);
							this.newsGuideHandler();
							if (res.url) {
								setTimeout(() => {
									location.href = res.url;
								}, 2000);
							}
						}
					}
				})
				.catch((e) => {
					console.log(`e`, e);
				});
		},
		//节日弹窗活动
		async frame() {
			await myAjax
				.post(apiPath.frame, {platform: 16})
				.then((res) => {
					this.$store.commit('setFrame', res.status);
					this.frameObj.image = res.image;
					this.frameObj.url = res.url;
				})
				.catch((e) => {});
		},
		async getPersonData() {
			await myAjax
				.get(apiPath.getPersonal)
				.then((res) => {
					//this.puid = res.id;
					this.$store.commit('setUserId', res.id);
					this.$store.commit('setUserType', res.type);
					localStorage.setItem('userType', res.type);
					this.$store.commit('setUserPhone', res.phone);
					this.$store.commit('setSeckillNew', res.created_time);
					this.$store.commit('setUserLevel', res.level);
					this.$store.commit('setUserInfo', res);
					// // 已登录用户绑定大数据userid
					// commonFn.linkUseridToSense(res.id);
				})
				.catch(/* e => this.layer(e)*/);
		},
		howdoPopClick() {
			this.$store.commit('setFreeListen', {
				name: 'howdoPop',
				val: false
			});
		},
		getWxPublicPayUrl() {
			myAjax
				.get(apiPath.wxPublicPayUrl, {
					key: 'pay_url'
				})
				.then((res) => {
					if (res.status) {
						this.$store.commit('setWxPublicPayUrl', res.status);
					}
				})
				.catch((e) => {});
		},
		getPayChannel() {
			myAjax
				.get(apiPath.wxPublicPayUrl, {
					key: 'h5_yqw_wechat_pay'
				})
				.then((res) => {
					if (res.status) {
						localStorage.setItem('payChannelObj', res.status);
					}
				})
				.catch((e) => {});
		}
	},
	created() {
		console.log(this.isLogin, 'isLogin', this.isYdk, 'isYdk');
		//解决统计代码未引入报错的问题
		window._hmt = null;

		this.$store.commit('setFrame', 0);
		if (this.qianId) {
			this.obj.isQian = true;
		} else {
			this.obj.isQian = false;
		}
		if (this.channel == 1518086499 || this.channel == 1518076272) {
			this.obj.isQudao = true;
		} else if (this.channel == 'zxzw_hh') {
			this.obj.isZXQudao = true;
		} else if (this.channel == 'zxzw_bzjp') {
			this.obj.isZXBZJPQudao = true;
		} else {
			this.obj.isQudao = false;
		}
		// 获取微信公众号支付域名
		this.getWxPublicPayUrl();
		// 获取支付渠道
		this.getPayChannel();
	},
	async mounted() {
		this.getQiFu();
		document.body.addEventListener('focusout', () => {
			//软键盘收起的事件处理
			window.scroll(0, 0);
		});
		if (this.userToken) {
			/* 用户已登录 */
			try {
				localStorage.setItem('yiQiWenToken', this.userToken);
				commonFn.setCookieItem('_token', this.userToken, Infinity, '/', 'yiqiwen.cn');
			} catch (e) {}
			/* 绑定签文 */
			if (this.qianId) {
				this.bindQian();
			}
			/* 环境分析专题页前往家具服务列表 */
			if (this.source == 'around') {
				this.$router.push({
					path: `/highAnswerList?high_cate_id=7&source=around`
				});
			}
			/* 绑定订单,如果有绑定订单不再触发新手流程 */
			if (this.order_id) {
				this.bindUserOrder();
			} else {
				if (this.batch) {
					this.coupon();
				} else {
					this.newsGuideHandler();
				}
			}
			this.getPersonData();
		} else {
			if (!commonFn.isH5()) {
				if (window.mmc.client.is('ljds')) {
					window.mmc.user.login(() => {
						location.reload();
					});
					return;
				}
				if (window.mmc.client.isAndroid()) {
					// 安卓灵机妙算3个页面，两个渠道不自动登录
					const closeLoginPath = ['/usercateList', '/', '/quickStep1', '/answerIndex'];
					const closeLoginChannel = [
						'lingji_ljms-az-sy',
						'1518086499',
						'lingji_ljms-az-yunshi'
					];
					if (
						!(
							window.mmc.client.is('ljms') &&
							closeLoginPath.includes(this.$route.path) &&
							closeLoginChannel.includes(this.channel)
						)
					) {
						window.mmc.user.login('window.yqwLogin');
					}
				} else {
					window.mmc.user.login(function iosYqwLogin(res) {
						sessionStorage.removeItem('login_times', 1);
						location.reload();
					});
				}
			}
		}
		let title = document.getElementsByTagName('title')[0];
		let footerbar = document.querySelector('.footerbar');
		// 去除页面页脚
		if (this.hideFooterPath.includes(this.$route.path)) {
			commonFn.hideFooter();
		} else {
			commonFn.showFooter();
		}
		// 保存渠道
		this.$store.commit('setChannel', this.channel);
		// 动态添加统计代码
		addStatisticsCode();
		// 路由进程守护
		this.$router.beforeEach((to, from, next) => {
			// 路径拼接query字段
			let query = '';
			let keys = Object.keys(to.query);
			if (keys.length) {
				query = '?';
				keys.forEach((key) => {
					if (keys.length == 1) {
						query += `${key}=${to.query[key]}`;
					} else {
						query += `${key}=${to.query[key]}&`;
					}
				});
			}
			_hmt && _hmt.push(['_trackPageview', to.path + `${query}`]);
			// 去除页面页脚
			if (this.hideFooterPath.includes(to.path)) {
				commonFn.hideFooter();
			} else {
				commonFn.showFooter();
			}
			if (to.path == '/' || to.path == '/usercateList' || to.path == '/courseIndex') {
				this.frame();
			}
			if (title.textContent !== '易起问-东方智慧语音咨询平台') {
				title.textContent = '易起问-东方智慧语音咨询平台';
			}
			next();
		});
	}
};
</script>



// WEBPACK FOOTER //
// app.vue?04b5ec07